import { Injectable } from '@angular/core';
import { User } from '../shared/user.model';
import { AppConfig } from '../config/app.config';



export interface UserDetails {

    userId: string,
    UserName: string,
    Department: string,
    Email: string,
}

@Injectable()
export class UserService {

    private _userKey: string = "CURRENT_USER";
    private _userRolesKey: string = "USER_ROLES";
    private currentSystem: string = this.config.get('currentsystem');


    constructor(private config: AppConfig) { }

    private auth_token = '';

    private user: UserDetails = {

        userId: '',
        UserName: '',
        Department: '',
        Email: '',

    };




    public sUsers: User;

    // You can use this operator if you know that the response will always return something than null
    //this.currentUser = JSON.parse(localStorage.getItem('currentUser')!);
    getAuthToken(): string {
        if (localStorage.getItem('auth_token')) {

            this.user = JSON.parse(localStorage.getItem('UserId'));

            return localStorage.getItem('auth_token')!;

        } else {
            return this.auth_token;
        }
    }
    setAuthToken(auth_token: string): void {
        this.auth_token = auth_token;
        localStorage.setItem('auth_token', auth_token);
    }

    setUser() {

        localStorage.setItem("userAuth", "true");
        localStorage.setItem("UserId", JSON.stringify(this.sUsers.UserId));
        localStorage.setItem("userRoles", this.sUsers.Roles.join(','));
        localStorage.setItem("userMenu", JSON.stringify(this.sUsers.MenuItems));
        localStorage.setItem("userData", JSON.stringify(this.sUsers));
        localStorage.setItem("isApprover", JSON.stringify(this.sUsers.IsApprover));
        localStorage.setItem("UserName", JSON.stringify(this.sUsers.UserName));
        localStorage.setItem("Department", JSON.stringify(this.sUsers.Department));
        localStorage.setItem("Email", JSON.stringify(this.sUsers.Email));
        localStorage.setItem("SupplierNumber", JSON.stringify(this.sUsers.SupplierNumber));
        localStorage.setItem("ExtendedSupplierNumber", JSON.stringify(this.sUsers.ExtendedSupplierNumber));


        if (this.currentSystem != "")
        localStorage.setItem("emulateResetUserData", JSON.stringify(this.sUsers));


    }

    get userRoles(): Array<string> {
        const userRoles = localStorage.getItem("userRoles");
        return userRoles.split(',');
    }

    get currentUser(): string {
        return localStorage.getItem(this._userKey);
    }

    set currentUser(user: string) {
        localStorage.setItem(this._userKey, user);
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/authentication-wam/user.service.ts